import { FC, useRef } from "react"
import writeXlsxFile from "write-excel-file"
import BaseApi from "../../../api/api"
import { RecodeKatrenItem } from "../../FormKatrenOrder/FormKatrenOrder"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import { Button } from "@radix-ui/themes"

export const DownloadRecodeWbBtn: FC = () => {
  const onClick = useRef(async () => {
    try {
      const { success, items } = await BaseApi.getWBKatrenRecode()
      if (success) {
        writeXlsxFile(items, {
          schema: RECODE_SCHEMA,
          fileName: "recodeWb.xlsx",
        })
      } else {
        NotificationService.showNotification({
          level: "error",
          message: "Произошла ошибка",
        })
      }
    } catch (e) {}
  })
  return <Button onClick={onClick.current}>Скачать перекодировку</Button>
}

const RECODE_SCHEMA = [
  {
    column: "GoodName",
    value: (item: RecodeKatrenItem) => item.GoodName,
  },
  {
    column: "GoodCode",
    value: (item: RecodeKatrenItem) => item.GoodCode,
  },
  {
    column: "nmId",
    value: (item: RecodeKatrenItem) => item.nmId,
  },
  {
    column: "sku",
    value: (item: RecodeKatrenItem) => item.sku,
  },
  {
    column: "count",
    value: (item: RecodeKatrenItem) => item.count,
  },
  {
    column: "commission",
    value: (item: RecodeKatrenItem) => item.commission,
  },
]
